"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopSystemMenuList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../../hooks");
const selectors_1 = require("../../store/selectors");
const SystemMenu_1 = require("../SystemMenu");
function DesktopSystemMenuList({ onOpen, resetButtonPressed, setResetButtonPressed, }) {
    const systems = (0, hooks_1.useSelector)(selectors_1.getSystemStates);
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    const [activeSystem, setIsActiveSystem] = (0, react_1.useState)('');
    const onItemClick = (id) => {
        setIsExpanded(true);
        setIsActiveSystem(id);
        onOpen(true);
    };
    const onClose = () => {
        setIsExpanded(false);
        onOpen(false);
    };
    (0, react_1.useEffect)(() => {
        if (systems.length === 1) {
            setIsExpanded(true);
            setIsActiveSystem(systems[0].identifier);
        }
    }, [systems]);
    const isSingleSystem = systems.length === 1;
    return ((0, jsx_runtime_1.jsxs)(Container, { "$isExpanded": isExpanded, "data-e2e": 'DesktopSystemMenuList_Container', children: [!isSingleSystem && isExpanded && (0, jsx_runtime_1.jsx)(StyledCloseButton, { onClick: onClose, "data-e2e": 'DesktopSystemMenuList_StyledCloseButton' }), (0, jsx_runtime_1.jsx)(List, { "data-e2e": 'DesktopSystemMenuList_List', children: systems.map(system => ((0, jsx_runtime_1.jsx)(SystemMenu_1.SystemMenu, { isExpanded: isExpanded, isSelected: system.identifier === activeSystem, system: system, onClick: onItemClick, resetButtonPressed: resetButtonPressed, setResetButtonPressed: setResetButtonPressed, "data-e2e": 'DesktopSystemMenuList_SystemMenu' }, system.identifier))) })] }));
}
exports.DesktopSystemMenuList = DesktopSystemMenuList;
const StyledCloseButton = (0, styled_components_1.default)(ui_1.CloseButton) `
  width: 40px;
  height: 40px;
  margin-left: 8px;
  margin-bottom: 4px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);

  &:focus-visible {
    outline: none;
    border: 2px solid ${({ theme }) => theme.designSystem.accent};
  }

  & svg {
    height: 20px;
    width: 20px;
  }
`;
const Container = styled_components_1.default.div `
  height: 100%;
  width: ${({ $isExpanded }) => ($isExpanded ? '290px' : '164px')};
  position: relative;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  background-color: ${({ theme }) => theme.grasshopper.background};
  overflow: hidden;
  padding-right: 4px;
  opacity: 0.9;
`;
const List = styled_components_1.default.div `
  position: relative;

  height: 100%;
  width: 100%;
  display: flex;

  box-sizing: border-box;

  flex-direction: column;
  // overflow: hidden;
  background-color: none;

  padding: 0px 8px 8px 8px;

  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.grasshopper.background};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.grasshopper.descriptionPanel.scroll.idle};

    border-radius: 6px;
  }
  &::-webkit-scrollbar-thumb:hover {
    opacity: 0.8;
  }
`;
